module.exports = __webpack_public_path__ + "img/seccion4.3.e13aed2b.png";